import React from "react";

export default function Header() {
  return (
    <div className="text-2xl pt-4 pb-4 bg-blue-200 font-bold text-center">
        STOLEN VEHICLE REPORT PORTAL
    </div>
  );
}
